import { render, staticRenderFns } from "./AnnualizationUser.vue?vue&type=template&id=b5fe5b10&scoped=true"
import script from "./AnnualizationUser.vue?vue&type=script&lang=js"
export * from "./AnnualizationUser.vue?vue&type=script&lang=js"
import style0 from "./AnnualizationUser.vue?vue&type=style&index=0&id=b5fe5b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fe5b10",
  null
  
)

export default component.exports